export const SUBMIT_FEEDBACK = "SUBMIT_FEEDBACK";
export const SEND_FEEDBACK_FAILED = "SEND_FEEDBACK_FAILED";
export const SEND_FEEDBACK_SUCCESS = "SEND_FEEDBACK_SUCCESS";
export const SEND_FEEDBACK = "SEND_FEEDBACK";
export const TOGGLE_SHOW_FEEDBACK_FORM = "TOGGLE_SHOW_FEEDBACK_FORM";
export const RESET_FEEDBACK_FORM = "RESET_FEEDBACK_FORM";

export const sendFeedback = data => {
    return {type: SUBMIT_FEEDBACK, data};
}

export const showFeedbackForm = toggle => {
    return {type: TOGGLE_SHOW_FEEDBACK_FORM, toggle};
}

export const resetFeedbackForm = () => {
    return { type: RESET_FEEDBACK_FORM }
}



// WEBPACK FOOTER //
// ./modules/Common/actions/feedbackForm.js